"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _reactDndCjs = require("react-dnd-cjs");

var _reselect = require("reselect");

var _core = require("@react-page/core");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var S = _interopRequireWildcard(require("./styled"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var target = {
  hover: (0, _lodash["default"])(function (props, monitor) {
    var item = monitor.getItem();

    if (monitor.isOver({
      shallow: true
    })) {
      item.clearHover();
    }
  }, 200, {
    trailing: false
  }),
  drop: function drop(props, monitor) {
    var item = monitor.getItem();

    if (monitor.didDrop() || !monitor.isOver({
      shallow: true
    })) {
      // If the item drop occurred deeper down the tree, don't do anything
      return;
    }

    props.removeCell(item.id);
  }
};

var connectMonitor = function connectMonitor(_connect, monitor) {
  return {
    connectDropTarget: _connect.dropTarget(),
    isOverCurrent: monitor.isOver({
      shallow: true
    })
  };
};

var Raw = function Raw(_ref) {
  var connectDropTarget = _ref.connectDropTarget,
      isOverCurrent = _ref.isOverCurrent,
      isLayoutMode = _ref.isLayoutMode;
  return connectDropTarget( /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames["default"])('ory-controls-trash', {
      'ory-controls-trash-active': isLayoutMode
    })
  }, /*#__PURE__*/React.createElement("button", {
    color: "secondary",
    disabled: !isOverCurrent,
    "data-testid": "trash-button"
  }, /*#__PURE__*/React.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTrash.faTrash
  }))));
};

var types = function types(_ref2) {
  var editor = _ref2.editor;
  var _editor$plugins$plugi = editor.plugins.plugins,
      content = _editor$plugins$plugi.content,
      layout = _editor$plugins$plugi.layout;
  var plugins = [].concat(_toConsumableArray(Object.keys(layout).map(function (p) {
    return layout[p].name;
  })), _toConsumableArray(Object.keys(content).map(function (p) {
    return content[p].name;
  })));

  if (editor.plugins.hasNativePlugin()) {
    plugins.push(editor.plugins.getNativePlugin()().name);
  }

  return plugins;
};

var mapDispatchToProps = {
  removeCell: _core.Actions.Cell.removeCell
};
var mapStateToProps = (0, _reselect.createStructuredSelector)(_core.Selectors.Display);
var Decorated = (0, _core.connect)(mapStateToProps, mapDispatchToProps)((0, _reactDndCjs.DropTarget)(types, target, connectMonitor)(Raw));

var Trash = function Trash(_ref3) {
  var editor = _ref3.editor;
  return /*#__PURE__*/React.createElement(S.Trash, null, /*#__PURE__*/React.createElement(Decorated, {
    editor: editor
  }));
};

var _default = Trash;
exports["default"] = _default;